<template>
  <div class="right-answer-wrapper" :style="{ top: `${top}px`, right: `${right}px` }">
    <h3 class="title">当前阶段</h3>
    <p class="current-stage">{{ rightAnswerRate.curStageName }}</p>
    <div class="percent-wrapper">
      <canvas-circle class="answer-circle" :id="'right-answer-circle'" :percent="rightAnswerRate.rightRate" :colorOption="colorOption"></canvas-circle>
      <div class="center-text">
        <p class="num">{{parseInt(rightAnswerRate.rightRate * 100)}}<span>%</span></p>
        <p class="text">正答率</p>
        </div>
    </div>
  </div>
</template>
<script>
import CanvasCircle from '@/components/CanvasCircle'

export default {
  name: "RightAnswerRate",
  components: {
    CanvasCircle
  },
  props: {
    rightAnswerRate: {
      type: Object
    },
    top: {
      type: Number,
      default: 150
    },
    right: {
      type: Number,
      default: 13
    }
  },
  data() {
    return {
      colorOption: {
        startColor: "#00DBFF",
        endColor: "#8CFFEF"
      }
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.right-answer-wrapper {
  width: 126px;
  height: 206px;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  text-align: center;
  background: url("./images/right-answer-bg.png") no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  position: absolute;
  z-index: 99;
  h3 {
    color: rgba(0, 255, 249, 1);
    font-weight: 600;
    line-height: 20px;
    margin-top: 12px;
  }
  .current-stage {
    font-size: 20px;
    font-weight: 600;
    color: rgba(0,255,249,1);
    line-height: 28px;
  }
  .percent-wrapper{
    width: 100px;
    height: 100px;
    margin: 16px auto;
    position: relative;
    background: url("./images/circle-bg.png") center center no-repeat;
    background-size: contain;
    &::before {
      content: "";
      display: inline-block;
      width: 100px;
      height: 100px;
      background: url("./images/timing.png") center center no-repeat;
      background-size: contain;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 200;
    }
    .answer-circle {
      position: absolute;
      top: 1px;
      left: -1px;
    }
    .center-text {
      width: 100%;
      font-size:24px;
      font-family:DINAlternate-Bold,DINAlternate;
      text-align: center;
      position: absolute;
      top: 29px;
      .num {
        color:rgba(144,255,252,1);
        font-weight:bold;
        line-height:24px;
        span {
          color: #90FFFC;
          font-size: 12px;
        }
      }
      .text {
        font-size:10px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(144,255,252,1);
        line-height:10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RightAnswerRate/index.vue